module.exports = __webpack_public_path__ + "static/img/icon.389b28f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/market/icon.png
// module id = 2Fqe
// module chunks = 1